import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeftRight } from 'lucide-react';
import { getThumbnailUrl, getThumbnailSrcSet } from '@/utils/thumbnailUtils';

interface VideoSelectorCompactProps {
  currentVideo: {
    id: string;
    title: string;
    thumbnailUrl: string;
  } | null;
  onChangeVideo: () => void;
}

export const VideoSelectorCompact: React.FC<VideoSelectorCompactProps> = ({ 
  currentVideo, 
  onChangeVideo 
}) => {
  useLanguage();
  if (!currentVideo) return null;
  
  return (
    <div className="flex items-center gap-3 p-2 bg-muted/30 rounded-lg border border-border hover:bg-muted/50 transition-colors">
      {/* Thumbnail */}
      <div className="relative w-[60px] h-[40px] rounded overflow-hidden flex-shrink-0 bg-muted thumb-container">
        <img 
          src={getThumbnailUrl(currentVideo.thumbnailUrl, '1280')}
          srcSet={getThumbnailSrcSet(currentVideo.thumbnailUrl)}
          alt={currentVideo.title}
          className="w-full h-full object-cover thumb-premium"
          loading="eager"
          decoding="async"
        />
      </div>
      
      {/* Título */}
      <div className="flex-1 min-w-0">
        <p className="text-xs text-muted-foreground mb-0.5">{translateInterfaceText("Vídeo atual")}</p>
        <p className="text-sm font-medium truncate" title={currentVideo.title}>
          {currentVideo.title}
        </p>
      </div>
      
      {/* Botão trocar */}
      <Button
        variant="ghost"
        size="sm"
        onClick={onChangeVideo}
        className="flex-shrink-0 h-8 px-2"
        title={translateInterfaceText("Trocar vídeo")}
      >
        <ArrowLeftRight className="h-4 w-4" />
        <span className="sr-only">{translateInterfaceText("Trocar vídeo")}</span>
      </Button>
    </div>
  );
};
